/** Persiste sesión en localStorage (p. ej. justo antes de salir a Mercado Pago). */
export function persistAuthSession({ user, token, refreshToken }) {
  if (token) localStorage.setItem('token', token);
  if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
  if (user) localStorage.setItem('user', JSON.stringify(user));
}

export function resolvePlanId(plan) {
  if (!plan) return null;
  return plan._id || plan.id || null;
}
